import { NavLink } from 'react-router-dom'
import { useAuth } from '@/lib/auth-context'
import { navItemsForRole, resolveNavLabel } from './nav-items'
import { cn } from '@/lib/utils'

export function BottomNav() {
  const { auth } = useAuth()
  if (!auth) return null

  const items = navItemsForRole(auth.role)

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 flex overflow-x-auto border-t border-sidebar-border bg-sidebar shadow-[0_-1px_3px_rgba(0,0,0,0.04)] md:hidden">
      {items.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'flex min-w-16 flex-1 flex-col items-center gap-0.5 px-2 py-2.5 text-[11px] font-medium text-sidebar-foreground/70',
              isActive && 'font-semibold text-sidebar-primary',
            )
          }
        >
          <item.icon className={cn('size-5', item.color)} />
          <span className="truncate">{resolveNavLabel(item, auth.role)}</span>
        </NavLink>
      ))}
    </nav>
  )
}
